import React from "react";
import { Card, CloseButton, Button } from "react-bootstrap";
import styled from "styled-components";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "../component/ItemTypes";
import { getUserSession } from "../component/userInfo";

const MyButton = styled.div`
  .close-delete {
    padding: 12px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
`;

const NextgenPhotoItem = ({
  imageInfo,
  photoType,
  index,
  movePhotoItem,
  width,
  mainButtonView,
  reloadPhotoList,
}) => {
  const ref = React.useRef(null);

  const [, drop] = useDrop({
    accept: ItemTypes.PHOTO,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      movePhotoItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.PHOTO,
    item: () => ({ id: imageInfo.photo_file_no, index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  const deleteImage = () => {
    if (window.confirm("해당 이미지를 삭제하시겠습니까?")) {
      const userSession = getUserSession();
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "delImg");
      formData.append("photoType", photoType);
      formData.append("photoFileNo", imageInfo.photo_file_no);
      fetch("https://work.wekoinonia.org/json/nextgenPhoto.php", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.code === "0000") {
            reloadPhotoList();
          }
          alert(json.msg);
        })
        .catch((error) => console.error("Error:", error));
    }
  };

  const changeMainPhoto = () => {
    if (window.confirm("메인 사진으로 변경하시겠습니까?")) {
      const userSession = getUserSession();
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "changeMainPhotoNo");
      formData.append("photoType", photoType);
      fetch("https://work.wekoinonia.org/json/nextgenPhoto.php", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.code === "0000") {
            reloadPhotoList();
          }
          alert(json.msg);
        })
        .catch((error) => console.error("Error:", error));
    }
  };

  let imgsrc = imageInfo.imgsrc.startsWith("http")
    ? imageInfo.imgsrc
    : "https://work.wekoinonia.org" + imageInfo.imgsrc;

  return (
    <div
      ref={ref}
      style={{ opacity, width: `${width}px`, display: "inline-block" }}
    >
      <Card className="m-1">
        <MyButton>
          <CloseButton onClick={deleteImage} className="close-delete" />
        </MyButton>
        <Card.Img variant="top" src={imgsrc} />
        {mainButtonView && (
          <Card.Body>
            <Button onClick={changeMainPhoto}>메인사진으로 변경</Button>
          </Card.Body>
        )}
      </Card>
    </div>
  );
};

export default NextgenPhotoItem;
